module.exports = __webpack_public_path__ + "img/img-1.fdaae9fd.webp";